// activityUsTrade
export default {
  routerTitle: '尋找美股交易達人',

  shareTitle: '尋找美股交易達人！',
  shareDesc: '限時免佣、免平台費！還有1000HKD現金獎勵等你來拿！',

  cardOneTitle: '限免激勵',
  usTrade: '美股交易',
  cardOneText1: '免佣金、免平台費',
  cardOneText2: '不限交易金額、次數',

  cardTwoTitle: '最高累計獎勵現金 HKD 1000',
  cardTwoRowRight: '累計獎勵',
  cardTwoRowLeft1: '交易 ≥ 20筆',
  cardTwoRowRight1: 'HKD 100',

  cardTwoRowLeft2: '交易 ≥ 50筆',
  cardTwoRowRight2: 'HKD 200',

  cardTwoRowLeft3: '交易 ≥ 100筆',
  cardTwoRowRight3: 'HKD 400',

  cardTwoRowLeft4: '交易 ≥ 500筆',
  cardTwoRowRight4: 'HKD 1000',

  cardTwoTips:
    '備註：客戶活動期間累計交易 20筆獲得 100現金，再交易 30筆累計交易 50筆 ，再獲得 100現金，共獲得 200現金；以此類推，最高可獲得 1000現金。'
}
